import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { locations } from 'services/routes/locations';
import { environmentManager } from 'services/api/config';

const DevOnly = ({ children }: { children: ReactElement }): ReactElement => {
  if (!environmentManager.isProductionEnv) {
    return children;
  }

  return <Navigate to={locations.other.blankPage.pathname} />;
};

export default DevOnly;
